import { combineReducers } from "redux";
import { Entities } from "../../../normalizr/entities";
import { messageImageSchema } from "../../../normalizr/ImageAnnotationsSchema";
import { createEntityReducer } from "../../../Redux/Entities/reducers";
import { Image } from "../types";

export type ImagesEntities = Entities<Image>;

export interface EntitiesState {
    images?: ImagesEntities;
}

export const imagesReducer = createEntityReducer(messageImageSchema.key);

const imagesEntityReducer = {
    images: imagesReducer,
};

export const entitiesReducer = combineReducers<EntitiesState>(imagesEntityReducer);
